import TemporaryActions from '../../prat_actions/gt/temporaryActions'

const TemporaryReducer = (state = {isGtLoading: false  }, action ) => {
    let details;
    switch (action.type) {
        case TemporaryActions.PRODUCT_DETAIL :
            return {
                ...state,
                isPrat1Loading:false,
                productDetail:action.data,
                details:action.data
            };        

        case TemporaryActions.GEO_DETAIL :
                return {
                    ...state,
                    isPrat1Loading:false,
                    geoDetail:details
                };        
    
        default :
          return {
              ...state
          };
    }
}

export default TemporaryReducer;